<template>
  <div class="content-box">
    <el-card class="box-card">
      <el-button @click="openConfiguration(1, {})" size="small" style="width: 100px;margin-bottom: 20px">批量配置
      </el-button>
      <el-table
          row-key="id"
          class="tableListValue"
          :height="tableHeight"
          v-loading="tableLoadingType"
          ref="table"
          :data="tableData"
          stripe
          style="width: 100%">
        <el-table-column
            :selectable='checkboxT'
            :reserve-selection="true"
            align="center"
            type="selection"
            width="50">
        </el-table-column>
        <el-table-column label="序号" type="index" width="60" align="center">
          <template #default="scope">
            <span v-text="getIndex(scope.$index)"></span>
          </template>
        </el-table-column>
        <el-table-column
            prop="vin"
            min-width="180"
            align="center"
            label="VIN">
        </el-table-column>
        <el-table-column
            prop="onlineStatus"
            width="110"
            align="center"
            label="终端工作状态">
          <template slot-scope="scope">
            {{ scope.row.onlineStatus !== '' ? onlineStatusObj[scope.row.onlineStatus] : '-' }}
          </template>
        </el-table-column>
        <el-table-column
            prop="status"
            width="80"
            align="center"
            label="配置状态">
          <template slot-scope="scope">
            {{ scope.row.status ? '成功' : '-' }}
          </template>
        </el-table-column>
        <el-table-column
            prop="deployName"
            width="80"
            align="center"
            label="配置名称">
        </el-table-column>
        <el-table-column
            prop="canChannel"
            width="80"
            align="center"
            label="CAN通道">
          <template slot-scope="scope">
            {{ canChannelObj[scope.row.canChannel] }}
          </template>
        </el-table-column>
        <el-table-column
            prop="dataType"
            align="center"
            width="80"
            label="数据类型">
          <template slot-scope="scope">
            {{ dataTypeObj[scope.row.dataType] }}
          </template>
        </el-table-column>
        <el-table-column
            prop="canId"
            width="80"
            align="center"
            label="帧ID(OX)">
        </el-table-column>
        <el-table-column
            prop="canType"
            width="80"
            align="center"
            label="ID类型">
          <template slot-scope="scope">
            {{ canTypeObj[scope.row.canType] }}
          </template>
        </el-table-column>
        <el-table-column
            prop="startBit"
            width="80"
            align="center"
            label="起始位">
        </el-table-column>
        <el-table-column
            prop="bitLength"
            width="80"
            align="center"
            label="长度(bit)">
        </el-table-column>
        <el-table-column
            prop="trms"
            width="100"
            align="center"
            label="有效值(OX)">
        </el-table-column>
        <el-table-column
            prop="modifTime"
            width="150"
            align="center"
            label="配置时间">
        </el-table-column>
        <el-table-column
            prop="modifer"
            width="80"
            align="center"
            label="配置账号">
        </el-table-column>
        <el-table-column
            prop="name"
            width="140"
            align="center"
            label="储存信号配置操作">
          <template slot-scope="scope">
            <el-link
                :disabled="scope.row.onlineStatus === 0"
                @click="openConfiguration(2, scope.row)"
                :underline="false"
                :type="scope.row.onlineStatus === 0?'info':'primary'"
                style="font-weight: 700">
              配置
            </el-link>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
        </el-pagination>
      </div>
    </el-card>
    <!--    配置弹框-->
    <div v-if="dialogVisible">
      <el-dialog :destroy-on-close="true" :before-close="handleClose" :title="dialogTitle"
                 :visible.sync="dialogVisible">
        <configuration-dialog @resetType="resetType"
                              :dialogType="dialogType"
                              :disableType="disableType"
                              :drawerForm="drawerForm"
                              @dialogClose="dialogClose"
                              @openHistory="openHistory"
                              :itemId="itemId"
                              :historyId="historyId"
                              :itemArrId="itemArrId"
        ></configuration-dialog>
      </el-dialog>
    </div>
    <!--    历史配置弹框-->
    <div v-if="dialogHistoryVisible">
      <el-dialog :destroy-on-close="true" title="历史配置" width="80%" :visible.sync="dialogHistoryVisible">
        <history-configuration @closeHistory="closeHistory"></history-configuration>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {getDeployPage} from "../../common/signalConfigurationApi";
import configurationDialog from "./components/configurationDialog";
import historyConfiguration from "./components/historyConfiguration";

export default {
  name: "signalConfiguration",
  components: {
    configurationDialog,
    historyConfiguration,
  },
  data() {
    return {
      onlineStatusObj: {
        0: '离线',
        1: '在线',
      },
      dataTypeObj: {
        0: 'Intel',
        1: 'Motorola LSB',
      },
      canChannelObj: {
        0: '通道0',
        1: '通道1',
      },
      canTypeObj: {
        0: '标准帧',
        1: '扩展帧',
      },
      historyId: 0,
      itemId: 0,
      itemArrId: 0,
      drawerForm: {},
      dialogType: 0,
      dialogTitle: '配置',
      dialogVisible: false,
      disableType: false,
      dialogHistoryVisible: false,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      tableLoadingType: false,
      tableHeight: 0,
      tableData: []
    }
  },
  mounted() {
    this.$nextTick(function () {
      this.tableHeight =
          window.innerHeight - this.$refs.table.$el.offsetTop - 85
    })
    this.getDeployPage()
  },
  methods: {
    checkboxT(row){
      return row.status !== 0;
    },
    getIndex(index) {
      return (this.currentPage - 1) * this.pageSize + index + 1
    },
    handleClose() {
      this.drawerForm = {}
      this.dialogVisible = false
    },
    resetType() {
      this.drawerForm = {}
      this.disableType = false
    },
    // 配置
    openConfiguration(type, item) {
      this.disableType = false
      this.dialogType = type
      if (type === 1) {
        const arr = this.$refs.table.selection;
        if (arr.length === 0) {
          this.$notify.error({
            title: '操作错误 !',
            message: '请选择数据后操作 !'
          })
          return
        }
        const ids = []
        for (const el of arr.values()) {
          ids.push(el.id)
        }
        this.itemArrId = ids
        this.dialogTitle = '批量配置'
        this.dialogVisible = true
      } else {
        console.log(item)
        this.itemArrId = []
        this.itemId = item.id
        this.dialogTitle = '配置'
        this.dialogVisible = true
      }

    },
    // 关闭弹框
    dialogClose() {
      this.drawerForm = {}
      this.getDeployPage()
      this.$refs.table.clearSelection();
      this.dialogVisible = false
    },
    // 关闭弹框---打开历史弹框
    openHistory() {
      this.dialogVisible = false
      this.dialogHistoryVisible = true
    },
    // 关闭历史配置---打开弹框
    closeHistory(param) {
      console.log(param)
      if (param.type === 2) {
        this.drawerForm = param.item
        this.historyId = param.item.id
        this.disableType = true
      }
      this.dialogVisible = true
      this.dialogHistoryVisible = false
    },
    // 获取列表
    async getDeployPage() {
      this.tableLoadingType = true
      try {
        const param = {
          pageNo: this.currentPage,
          pageSize: this.pageSize,
        }
        const res = await getDeployPage(param)
        if (res.code === 200) {
          this.tableData = res.data
          this.total = res.total
          this.tableLoadingType = false
        } else {
          this.$notify.error({
            title: '错误提示',
            message: res.msg
          });
          this.tableLoadingType = false
        }
      } catch (e) {
        this.tableLoadingType = false
        console.log(e)
      }
    },
    handleSizeChange(e) {
      this.pageSize = e
      this.getDeployPage()
    },
    handleCurrentChange(e) {
      this.currentPage = e
      this.getDeployPage()
    },
  }
}
</script>

<style scoped>
.pagination {
  margin-top: 10px;
  text-align: right;
}

.box-card {
  text-align: left;
  border-radius: 10px;
  height: 100%;
}
</style>
<style scoped lang="scss">
.tableListValue {
  //滚动条的宽高
  ::-webkit-scrollbar {
    width: 1vh;
    height: 1vh;
  }

  //滚动条的滑块背景色
  ::-webkit-scrollbar-thumb {
    background: #ccc;
    border-radius: 2vh;
  }

  //滚动条的背景色
  ::-webkit-scrollbar-track {
    background: rgba(#ccc, 0.3);
  }

}


/* 设置滚动条的样式 */
/*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/

::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}


/*定义滚动条轨道 内阴影+圆角*/

::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(255, 255, 255, 0.1);
  border-radius: 4px;
  background-color: #F5F5F5;
}


/*定义滑块 内阴影+圆角*/

::-webkit-scrollbar-thumb {
  border-radius: 4px;
  -webkit-box-shadow: inset 0 0 6px rgba(255, 255, 255, 0.1);
  background-color: #ccc;

}

</style>
